// @flow
import api from 'app/actions/api';
import pick from 'ramda/es/pick';
import get from 'app/common/lib/get';

export const KITS_REQUEST = 'orgs/KITS_REQUEST';
export const KITS_SUCCESS = 'orgs/KITS_SUCCESS';
export const KITS_SUCCESS_DELETED = 'orgs/KITS_SUCCESS_DELETED';
export const KITS_FAILURE = 'orgs/KITS_FAILURE';
export const KITS_STATE_CLEAR = 'orgs/KITS_STATE_CLEAR';

/**
* Запрос комплектов для школы
*/

export const kitsRequest = (payload: Object) => ({
  type: KITS_REQUEST,
  payload,
});

export const kitsSuccess = (payload: Object, copyInProgress?: boolean) => ({
  type: KITS_SUCCESS,
  payload,
  copyInProgress,
});

export const kitsSuccessDeleted = (payload: Object, copyInProgress?: boolean) => ({
  type: KITS_SUCCESS_DELETED,
  payload,
  copyInProgress,
});

export const kitsFailure = (payload: Object) => ({
  type: KITS_FAILURE,
  payload,
});

export const kitsStateClear = () => ({
  type: KITS_STATE_CLEAR,
});

type Params = {
  date?: string,
  deleted?: boolean,
  visible?: boolean,
  include_subsidy_orders?: boolean,
  building_id?: number, // опционально, работает только при заданной дате и вернет вариант комплекта для корпуса
  diet_food_type_id?: number // опционально, работает только при заданной дате и вернет вариант комплекта для вида диет. питания
}

export const kitsFetch = (orgId: string, params?: Params, isMixed: boolean) => async (dispatch: Function) => {
  dispatch(kitsRequest({ orgId, ...params }));
  try {
    if (isMixed) {
      const [res1, res2] = await Promise.all([
        api(`food/schools/${orgId}/complexes`, 'get', { params: pick(['include_subsidy_orders', 'visible', 'building_id', 'diet_food_type_id'], params) }),
        api(`food/schools/${orgId}/complexes`, 'get', { params }),
      ]);

      const data = {
        ...get(res1, ['data', 'complexes'], {}),
        ...get(res2, ['data', 'complexes'], {}),
      };
      const copyInProgress = Boolean(
        get(res1, ['data', 'copy_in_progress'], false)
        || get(res2, ['data', 'copy_in_progress'], false)
      );

      if (params && params.deleted) {
        dispatch(kitsSuccessDeleted(data, copyInProgress));
        return;
      }
      dispatch(kitsSuccess(data, copyInProgress));
    } else {
      const res = await api(`food/schools/${orgId}/complexes`, 'get', { params });
      // удаленные только в isMixed
      dispatch(kitsSuccess(
        get(res, ['data', 'complexes'], {}),
        Boolean(get(res, ['data', 'copy_in_progress'], false))
      ));
    }
  } catch (error) {
    dispatch(kitsFailure({ err: 'Запрос комплектов блюд школы не удался', error }));
  }
};
